"use strict";

exports.__esModule = true;
exports.dedupeArray = dedupeArray;
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function dedupeArray(input) {
  var output = [];
  var _loop = function _loop() {
    var item = input[i];
    if (!output.some(function (candidate) {
      return (0, _reactFastCompare["default"])(candidate, item);
    })) {
      output.push(item);
    }
  };
  for (var i = 0; i < input.length; i++) {
    _loop();
  }
  return output;
}